import useUserStore from '@/store/user.store';
import usePermissionStore from '@/store/permission.store';
import useTagsViewStore from '@/store/tagsView.store';
import useAppStore from '@/store/app.store';
import NProgress from 'nprogress';
import { loadingUtils } from '@/utils/loading';
import type { Router } from 'vue-router';
import { nextTick } from 'vue';

// 白名单路由
const whiteList = ['/login', '/404', '/403'];

// 跟踪是否需要关闭 loading
let pendingLoading = false;

/**
 * 获取 pendingLoading 状态
 */
export function getPendingLoading(): boolean {
  return pendingLoading;
}

/**
 * 重置 pendingLoading 状态
 */
export function resetPendingLoading(): void {
  pendingLoading = false;
}

/**
 * 关闭 loading 效果
 */
function closeLoading(): void {
  if (pendingLoading) {
    nextTick(() => {
      loadingUtils.hideLoading();
      pendingLoading = false;
    });
  }
}

export function setupBeforeEach(router: Router) {
// 全局前置守卫
  router.beforeEach(async (to, from, next) => {
    const appStore = useAppStore();
    const userStore = useUserStore();
    const permissionStore = usePermissionStore();
    const tagsViewStore = useTagsViewStore();

    // 设置页面标题
    document.title = to.meta.title ? `${to.meta.title} - TheBusManage` : 'TheBusManage';

    const hasToken = userStore.token;

    // 启动进度条
    // if (to.fullPath !== from.fullPath) {
    //   if (appStore.showNprogress) {
    //     NProgress.start();
    //   }
    // }
    // 动态路由生成前，不触发 NProgress
    const isDynamicRouteInit = !permissionStore.addRoutes || permissionStore.addRoutes.length === 0;

    if (!isDynamicRouteInit && to.fullPath !== from.fullPath) {
      if (appStore.showNprogress) {
        NProgress.start();
      }
    }

    if (hasToken) {
      if (to.path === '/login') {
      // 已登录，跳转登录
        next();
      } else {
      // 检查是否已经加载了路由
        const hasRoutes = permissionStore.addRoutes && permissionStore.addRoutes.length > 0;

        if (hasRoutes) {
          next();
        } else {
          try {
          // 显示 loading
            pendingLoading = true;
            loadingUtils.showLoading();
            // 获取用户信息
            // void userStore.getUserInfo();

            // 根据角色生成可访问路由
            const accessRoutes = await permissionStore.generateRoutes([]);
            // 动态添加路由

            accessRoutes.forEach(route => {
              // 如果是 404 等全局路由，直接添加
              if (route.path.startsWith('/:')) {
                router.addRoute(route);
              } else {
                // 业务路由添加到 Layout 下
                router.addRoute('Layout', route);
              }
            });

            // 清理无效的标签视图（在动态路由加载完成后）
            const validPaths = router.getRoutes().map(route => route.path);

            tagsViewStore.cleanInvalidViews(validPaths);

            // 继续路由跳转
            next({ ...to, replace: true });
          } catch (error) {
            console.error('加载路由失败:', error);
            // 移除 token 并跳转到登录页
            await userStore.logout();
            next(`/login?redirect=${to.path}`);
          }
        }
      }
    } else {
    // 未登录
      if (whiteList.includes(to.path)) {
      // 在白名单中，直接进入
        next();
      } else {
      // 否则跳转到登录页
        next(`/login?redirect=${to.path}`);
      }
    }
  });
}
